<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card header="Información del Cheque">
          <b-form>
            <b-form-group
              label="Cliente"
              label-for="cliente"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="cliente"
                :value="clienteNombre" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Emisión"
              label-for="fechaEmision"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaEmision" 
                v-model="fechaEmision" 
                type="date">
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Fecha Pago"
              label-for="fechaPago"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaPago" 
                v-model="fechaPago" 
                type="date">
              </b-form-input>
            </b-form-group>

            <app-banco
              label="Banco"
              :nombre="bancoNombre"
              :lista="bancosList"
              :labelCols="labelCols"
              :valido="bancoValido"
              :msjInvalido="bancoInvalidoMsj"
              @updated="bancoActualizado">
            </app-banco>

            <!-- <app-cliente
              label="Cliente"
              :nombre="clienteNombre"
              :valido="clienteValido"
              :lista="clientesList"
              :labelCols="labelCols"
              :msjInvalido="clienteInvalidoMsj"
              @updated="clienteActualizado">
            </app-cliente>   -->

            <b-form-group
              label="Titular"
              label-for="titular"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="titular"
                v-model.trim="$v.titular.$model" 
                :state="titularValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularFeedback">
                {{ titularInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="CUIT"
              label-for="titularCuit"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="titularCuit"
                v-model.trim="$v.titularCuit.$model" 
                :state="titularCuitValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="titularCuitFeedback">
                {{ titularCuitInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Serie"
              label-for="serie"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="serie"
                v-model.trim="$v.serie.$model" 
                :state="serieValida"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="serieFeedback">
                {{ serieInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Numero"
              label-for="numero"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="numero"
                v-model.trim="$v.numero.$model" 
                :state="numeroValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroFeedback">
                {{ numeroInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Importe"
              label-for="importe"
              :labelCols="labelCols"
              horizontal>
              <b-form-input 
                id="importe"
                :value="importe | moneda" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goBack">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Banco from '../shared/abmSelect.vue';
// import Cliente from '../shared/abmSelect.vue';
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, requiredIf, numeric, decimal, maxLength, minValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'chequetercero/getField',
  mutationType: 'chequetercero/updateField',
});

const CUIT = ((value) => {
  if (value == '') {
    return true
  } else {
    if (isNaN(parseInt(value))) {
      return false
    } else {
      var length = Math.log(value) * Math.LOG10E + 1 | 0;  
      if (length == 0 || length == 11)
        return true
      else
        return false
    }
  }
})

export default {
  name: 'ABM',
  components: {
    appBanco: Banco,
    // appCliente: Cliente,
    appABMButton: ABMButtons,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      // clienteValido: null,
      // clienteInvalidoMsj: '',
      bancoValido: null,
      bancoInvalidoMsj: '',
      titularValido: null,
      titularInvalidoMsj: '',
      titularCuitValido: null,
      titularCuitInvalidoMsj: '',
      serieValida: null,
      serieInvalidaMsj: '',
      numeroValido: null,
      numeroInvalidoMsj: '',
      // importeValido: null,
      // importeInvalidoMsj: '',

      bancos: [],
      bancosList: [],
      // clientes: [],
      // clientesList: [],

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'id',
      'fechaEmision',
      'fechaPago',
      'banco',
      'bancoNombre',
      // 'cliente',
      'clienteNombre',
      'titular',
      'titularCuit',
      // 'sinNumero',
      'serie',
      'numero',
      'importe',
    ])
  },  
  created() {
    let chequeTerceroId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        chequeTerceroId = this.$route.params.id;
      }
    }

    this.showSpinner();
    this.$store.dispatch('chequetercero/inicializar', chequeTerceroId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      const vm = this;

      vm.$store.dispatch('bancos/getBancosList')
        .then(() => {
          vm.bancos = this.$store.getters['bancos/bancosList'];
          vm.bancosList = this.$store.getters['bancos/bancosSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de bancos.'));

      // vm.$store.dispatch('clientes/getList')
      //   .then(() => {
      //     vm.clientes = this.$store.getters['clientes/list'];
      //     vm.clientesList = this.$store.getters['clientes/selectList'];
      //   })
      //   .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de clientes.'));
    },
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar)
          {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'titular' || validarTodos) {
        if (this.$v.titular.$error) {
          this.titularValido = false;
          if (!this.$v.titular.maxLength) {
            this.titularInvalidoMsj = 'El nombre del titular solo puede contener hasta 50 caracteres';
          }      
        } else {
          this.titularValido = null;
          this.titularInvalidoMsj = '';
        }
      }

      if (campo == 'titularCuit' || validarTodos) {
        if (this.$v.titularCuit.$error) {
          this.titularCuitValido = false;
          if (!this.$v.titularCuit.CUIT) {
            this.titularCuitInvalidoMsj = 'Verifique por favor el CUIT ingresado';
          } else if (!this.$v.cuit.numeric) {
            this.titularCuitInvalidoMsj = 'El CUIT del titular solo puede contener números';
          }      
        } else {
          this.cuitValido = null;
          this.cuitInvalidoMsj = '';
        }
      }

      if (campo == 'serie' || validarTodos) {
        if (this.$v.serie.$error) {
          this.serieValida = false;
          if (!this.$v.serie.required) {
            this.serieInvalidaMsj = 'Debe ingresar el número de serie';
          } else if (!this.$v.serie.maxLength) {
            this.serieInvalidaMsj = 'El número de serie solo puede contener hasta 5 caracteres';
          }      
        } else {
          this.serieValida = null;
          this.serieInvalidaMsj = '';
        }
      }

      if (campo == 'numero' || validarTodos) {
        if (this.$v.numero.$error) {
          this.numeroValido = false;
          if (!this.$v.numero.required) {
            this.numeroInvalidoMsj = 'Debe ingresar el número de cheque';
          } else if (!this.$v.numero.minValue) {
            this.numeroInvalidoMsj = 'Debe ingresar el número de cheque';
          } else if (!this.$v.numero.numeric) {
            this.numeroInvalidoMsj = 'El número de cheque debe ser un valor numérico';
          }      
        } else {
          // let errorNumero = false;

          // if (!(/true/i).test(this.sinNumero)) {
          //   let numero = parseInt(this.numero);
          //   if (numero == 0) {
          //     errorNumero = true;
          //     this.numeroValido = false;
          //     this.numeroInvalidoMsj = 'Debe ingresar el número de cheque';
          //   }
          // }

          // if (!errorNumero) {
            this.numeroValido = null;
            this.numeroInvalidoMsj = '';
          // }
        }
      }

      // if (campo == 'importe' || validarTodos) {
      //   if (this.$v.importe.$error) {
      //     this.importeValido = false;
      //     if (!this.$v.importe.decimal) {
      //       this.importeInvalidoMsj = 'El importe del cheque debe ser un valor numérico';
      //     } else if (!this.$v.importe.minValue) {
      //         this.importeInvalidoMsj = 'El importe del cheque no es válido';
      //     }     
      //   } else {
      //     this.importeValido = null;
      //     this.importeInvalidoMsj = '';
      //   }
      // }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let banco = null;
      if (this.bancoNombre) {
        banco = this.getSelected(this.bancos, this.bancoNombre);
      }

      this.$store.dispatch('chequetercero/setBanco', banco);

      this.$v.$touch();

      let save = true;

      let bancoError = true;
      if (this.banco) {
        if (this.banco.id) {
          if (this.banco.id != 0) {
            bancoError = false;
          }
        }
      }
      if (bancoError) {
        save = false;
        this.bancoValido = false;
        this.bancoInvalidoMsj = 'Debe seleccionar el banco correspondiente.';
      }

      if (save) {
        if (this.$v.$anyError) {
          this.displayErrores();
        } else {
          this.showSpinner = true;
          this.$store.dispatch('chequetercero/save')
            .then(() => this.showModalMsj('Los cambios se registraron con éxito.', this.goList, this.goList, 'light'))
            .catch(error => this.showErrorMsj(error))
            .finally(() => this.hideSpinner());
        } 
      }
    },
    goBack() {
      this.$router.push({ name: "ChequesTerceros" });
    },
    goList() {
      this.$router.push({ name: "ChequesTerceros" });
    },
    bancoActualizado(bancoNombre) {
      this.bancoNombre = bancoNombre;

      if (this.bancoNombre ) {
        this.bancoValido = null;
        this.bancoInvalidoMsj = '';
      }
    },
    // clienteActualizado(clienteNombre) {
    //   this.clienteNombre = clienteNombre;

    //   if (this.clienteNombre ) {
    //     this.clienteValido = null;
    //     this.clienteInvalidoMsj = '';
    //   }
    // },
  },
  watch: {
    // 'sinNumero' : function(newVal, oldVal) {
    //   if (this.sinNumero) {
    //     this.serie = '';
    //     this.numero = 0;
    //   }
    // },    
  },
  validations: {
    titular: {
      maxLength: maxLength(50)
    },
    titularCuit: {
      maxLength: maxLength(11)
    },
    serie: {
      // required: requiredIf(function () {
      //   return !this.sinNumero;
      // }),
      required,
      maxLength: maxLength(5)
    },
    numero: {
      // required: requiredIf(function () {
      //   return !this.sinNumero;
      // }),
      required,
      numeric,
      minValue: minValue(1)
    },
    // importe: {
    //   decimal,
    //   minValue: minValue(0)
    // },
  },  
}
</script>

<style>
</style>
